export default [
  {
    id: 1,
    name: "LABIOPLASTIKA",
    text: "Sleva 1000 Kč",
    icon: "doctor",
    pdf: "LABIOPLASTIKA_01_20.pdf",
    img: ["labioplastika_01_20.jpg"],
    desc: `V posledních letech se přistupuje k estetickým úpravám i těch nejintimnějších míst - zevních oblastí ženského pohlavního ústrojí. Jedná se o zbytnělé nebo zvětšené malé stydké pysky. Operace ženského genitálu (labioplastika) je doporučována ženám, kterým tato intimní „nedokonalost" způsobuje obtíže. Vliv na psychiku a sebevědomí ženy může být v těchto případech značný.<br/><br/>
          My Vám na tento zákrok nabízíme slevu 1000 Kč a k tomu registraci zcela zdarma.<br/><br/>
          Akce je platná od 1.1.2020 - 31.3.2020. Pro uplatnění této akce je nutné objednat se na konzultaci, či zákrok v daných 3 měsících a vytisknout si slevový kupón, který poté předložíte na konzultaci u lékaře. V případě, že slevovou akci chcete využít v jiném období, je nutné celý zákrok uhradit předem.`
  },
  {
    id: 2,
    name: "PLAZMATERAPIE",
    text: "Sleva 10%",
    icon: "care",
    pdf: "Plazmaterapie_01_20.pdf",
    img: ["plazmaterapie_01_20.jpg"],
    desc: `Vějířky kolem očí, rtů či na čele, hluboké vrásky nebo třeba vypadávání vlasů. Všechny  tyto vaše problémy dokáže vyřešit plazmaterapie.<br/><br/>
        Plazma, především krevní destičky v ní obsažené, jsou hlavním stimulátorem pro růst buněk kůže, ale také podporují aktivitu buněk v místě aplikace. <br/><br/>
        My Vám na tento zákrok nabízíme slevu 10%.<br/><br/>
        Akce je platná od 1.1.2020 - 31.3.2020. Pro uplatnění této akce je nutné objednat se na konzultaci, či zákrok v daných 3 měsících a vytisknout si slevový kupón, který poté předložíte na konzultaci u lékaře. V případě, že slevovou akci chcete využít v jiném období, je nutné celý zákrok uhradit předem.`
  },
  {
    id: 3,
    name: "PERMALIP",
    text: "Sleva 1000 Kč",
    icon: "female-mouth-lips",
    pdf: "PERMALIP_01_20.pdf",
    img: ["permalip_01_20.jpg"],
    desc: `PermaLip je permanentní implantát do rtů vyrobený z měkkého, jednolitého silikonového eleastomeru a je k dispozici v různých velikostech pro uspokojení individuálních potřeb klientů - od mírného zvýraznění rtů až po plné smyslné rty. Výhoda zvětšení rtů pomocí implantátu spočívá v okamžitém efektu, který je trvalý. Do rtů, které jsou úzké a vytváří tak dojem přísného obličeje nebo vzhledu je ideální použít tento implantát - rty mají po jeho aplikaci plnější objem a pěkné kontury.<br/><br/> 
            My Vám na tento zákrok nabízíme slevu 1000 Kč a k tomu registraci zcela zdarma.<br/><br/>
            Akce je platná od 1.1.2020 - 31.3.2020. Pro uplatnění této akce je nutné objednat se na konzultaci, či zákrok v daných 3 měsících a vytisknout si slevový kupón, který poté předložíte na konzultaci u lékaře. V případě, že slevovou akci chcete využít v jiném období, je nutné celý zákrok uhradit předem.`
  },
  {
    id: 4,
    name: "DARUJTE DÁRKOVÝ POUKAZ",
    text: "Poukaz",
    icon: "gift-card",
    desc: `Pokud chcete udělat radost svým blízkým, ale nejste si jisti, že se svým výběrem “ trefíte do noty “, nabízíme Vám dárkové poukazy v libovolné hodnotě, které Vaši blízcí mohou uplatnit na všech našich pobočkách a vybrat si mohou z mnoha špičkových lékařů s bohatými zahraničními zkušenostmi.`
  },
]



// WEBPACK FOOTER //
// ./src/texts/czech/sales.js